import {Actions, createEffect, ofType} from '@ngrx/effects';
import { Injectable, inject } from '@angular/core';
import {AssessmentAttemptActions, LessonActions} from './action-types';
import {concatMap, filter, map, withLatestFrom} from 'rxjs/operators';
import {AppState} from './index';
import {select, Store} from '@ngrx/store';
import {selectActiveCourse, selectActiveLesson, selectUser} from './selectors';
import {loadAssessmentAttemptSuccess, loadCourseAssessmentsSuccess} from './assessment.actions';
import { AssessmentService } from '../services/assessment.service';
import { selectActiveLessonAssessmentAttempt } from './assessment-attempts.selector';
import { from } from 'rxjs';


@Injectable()
export class AssessmentAttemptsEffects {
  private store = inject<Store<AppState>>(Store);
  private actions$ = inject(Actions);
  private assessmentAttemptsDB = inject(AssessmentService);


  createNewAssessmentAttempt$ = createEffect(() =>
    this.actions$.pipe(
      ofType(AssessmentAttemptActions.assessmentAttemptCreated),
      concatMap(action => from(this.assessmentAttemptsDB.startAssessmentAttempt(
          action.userId,
          action.assessmentId,
          action.attempt.totalQuestions,
          action.courseId,
          action.attempt.attemptNumber
        )).pipe(
          map(attemptId => ({ ...action, attemptId }))
        )
      )    )
  );


loadLessonAssessmentAttempt$ = createEffect( () =>
  this.actions$.pipe(
    ofType(LessonActions.watchLesson, AssessmentAttemptActions.loadAssessmentAttempt),
    withLatestFrom(
      this.store.pipe(select(selectActiveLesson)),
      this.store.pipe(select(selectActiveLessonAssessmentAttempt)),
      this.store.pipe(select(selectUser)),
    ),
    filter(([action, lesson, attempt, user]) => lesson.type == "assessment"),
    concatMap(([action, lesson, attempt, user]) => this.assessmentAttemptsDB.getLatestAttempt(user.id, lesson.id)),
    filter(attempt => !!attempt),
    map(attempt => loadAssessmentAttemptSuccess({ attempt }))
  )
);

loadCourseAssessments$ = createEffect( () =>
  this.actions$.pipe(
    ofType(AssessmentAttemptActions.loadCourseAssessments),
    withLatestFrom(
      this.store.pipe(select(selectActiveCourse)),
      this.store.pipe(select(selectUser)),
    ),
    concatMap(([action, course, user]) => this.assessmentAttemptsDB.getCourseAssessments(user.id, course.id)),
    filter(attempt => !!attempt),
    map(attempts => loadCourseAssessmentsSuccess({ attempts }))
  )
);

  /** Inserted by Angular inject() migration for backwards compatibility */
  constructor(...args: unknown[]);


  constructor() {
  }

}
